module.exports = {
  searchBox: "Enter your query...",

  title: {
    words: "CSV Words analyzer",
    ads: "CSV Ads analyzer"
  },

  csvOrTsv: "TSV or CSV",
  inputError: {
    title: "File input error",
    extension: ({ ext }) => "File with extension "+ext+" is not supported",
    type: ({ fileType }) => "File type "+fileType+" is not supported",
    adsQuery: () => "Ads analyzer supports only ads performance reports.",
    format: () => "File format not supported."
  }
}



// WEBPACK FOOTER //
// ../i18n/en/csvAnalyzer.js